import { BaseModel } from "./base.model";

export class AppVersionModel extends BaseModel {
    version: string;
    releaseDate: string;
    deleted: boolean;
}

export class AppVersionFeatureModel extends BaseModel {
    appVersionId: number;
    featureTitle: string;
    featureDescription: string;
    type: string;
}